import React from 'react';
import styled from 'styled-components';
import Icon from '@mdi/react';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import {
  mdiCloudCog,
  mdiWan,
  mdiServerNetwork,
  mdiTablet,
  mdiPrinterPos,
  mdiCreditCardOutline,
  mdiCashRegister,
} from '@mdi/js';

const StyledIcon = styled(Icon)`
  color: ${props => props.theme.text};
`;

const renderIconType = (deviceType: string) => {
  switch (deviceType) {
    case DeviceType.CLOUD_SERVICES:
      return mdiCloudCog;
    case DeviceType.NETWORK_CIRCUIT:
      return mdiWan;
    case DeviceType.NETWORK_SWITCH:
      return mdiServerNetwork;
    case DeviceType.IPAD:
      return mdiTablet;
    case DeviceType.IPAD_MINI:
      return mdiTablet;
    case DeviceType.RECEIPT_PRINTER:
      return mdiPrinterPos;
    case DeviceType.PAYMENT_TERMINAL:
      return mdiCreditCardOutline;
    case DeviceType.CASH_DRAWER:
      return mdiCashRegister;
    case DeviceType.BARCODE_SCANNER:
      return mdiCashRegister;
    case DeviceType.REGISTER:
      return mdiCashRegister;
    default:
      return mdiCloudCog;
  }
};

interface NikePOSIconProps {
  deviceType: DeviceType;
}

export default function NikePOSIcon({deviceType}: NikePOSIconProps) {
  const iconType = renderIconType(deviceType);
  return <StyledIcon path={iconType} />;
}
